import { BaseTextFieldProps, TextField as MuiTextField } from '@mui/material'
import { commonStyling } from './common';


interface TextFieldProps extends BaseTextFieldProps{
    inputPlaceholder: string;
}

const TextField = (props: TextFieldProps) => {
    return (
        <MuiTextField
            {...props}
            placeholder={props.inputPlaceholder}
            sx={{...commonStyling}}
        />
    )
}

export default TextField